import * as React from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend
} from "recharts";
import { RespuestaReporteGeneral } from "../modelo/ReporteGlosasModelo";
import { Glyphicon, OverlayTrigger, Tooltip as TooltipAyuda } from "react-bootstrap";

export default class GraficaBarras extends React.Component<GraficaBarrasProps, any> {

    seleccionServicio = (data) => {
        const servicioSeleccionado = this.props.datos[data.activeTooltipIndex];
        this.props.consultaDetalle(servicioSeleccionado.servicio);
    }

    render() {
        const { datos } = this.props;

        datos.forEach((dato, indice) => {
            dato.nombre = dato.nombre.substring(0, 12);
        });

        const tooltip = (
            <TooltipAyuda id="tooltip" className="tooltip-pos" arrowOffsetTop={20}>{"Avanzar"}</TooltipAyuda>
        );

        const anchoGrafico = datos.length <= 10 ? 1120 : datos.length * 112;

        return (
            <div className={"card"} >
                <div className={"card-header"}>
                    <h3 className={"panel-title"}>Reporte de Glosas por Servicio
                        {this.props.verBotonIrDetalle &&
                            <button type="button" className="btns-glyphicon" style={{ float: "right", marginRight: "40px" }} onClick={this.props.irADetalle}>
                                <OverlayTrigger placement="top" overlay={tooltip}>
                                    <Glyphicon glyph={"chevron-right"} style={{ width: "22px", height: "22px" }} />
                                </OverlayTrigger>
                            </button>
                        }
                    </h3>
                </div>
                <div className={"card-body"} style={datos.length > 10 ? { overflowX: "auto", whiteSpace: "nowrap" } : {}}>
                    <BarChart
                        width={anchoGrafico}
                        height={400}
                        data={datos}
                        margin={{
                            top: 5,
                            right: 20,
                            left: 0,
                            bottom: 5
                        }}
                        onClick={this.seleccionServicio}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="nombre" tickSize={10} style={{ fontSize: "10px" }} />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey="OK" fill="#82ca9d" />
                        <Bar dataKey="Glosa" fill="#1637f2" />
                        <Bar dataKey="Error" fill="#e63030" />
                    </BarChart>
                </div>
            </div>
        );
    }
}


interface GraficaBarrasProps {
    datos: Array<RespuestaReporteGeneral>,
    verBotonIrDetalle: boolean,
    consultaDetalle?: (codigoServicio: number) => void,
    irADetalle?: () => void
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/reporte_glosas/componentes/GraficaBarras.tsx